import getSection from '../../utils/getSection';

export const DDC_FORM_SLIDECHANGE = 'ddc.form.slideChange';

function slideChange({ target } = {}, { handle, values } = {}) {
	const element = handle || target;
	// const {
	// 	handle: target = e.target,
	// 	values
	// } = ui;
	const label = $(element)
		.closest('.ui-slider')
		.siblings('input')
		.attr('name');
	const section = getSection(element);
	const eventObject = {
		eventType: DDC_FORM_SLIDECHANGE,
		eventData: {
			element,
			label,
			values
		}
	};

	if (section) {
		eventObject.eventData.trackingSection = section;
	}

	return eventObject;
}

export default slideChange;
